export class Key {

  /**
   * 生成 24 位 key 用于 OSS 上传，并添加租户 code 最为文件前缀
   * 为了提高随机性，使用毫秒时间戳，转换为 16 进制后反转，剩余空位使用 16 进制的随机数补齐，全长 24 位。
   * 非生产环境时会自动添加 devtmp 前缀
   */
  generate(code: string, prefix?: string): string {
    const timestamp = Date.now();
    const key = timestamp
      .toString(16)
      .split('')
      .reverse()
      .join('')
      .padEnd(24, 'x')
      .replace(/[x]/g, () => Math.floor(Math.random() * 16).toString(16));

    return [
      prefix,
      code,
      key
    ].filter(str => Boolean(str)).join('/');
  }

}
